import {
  calcolaPrefatturazione,
  gruppoStampabile,
  daFatturare,
  righePrefatturazione,
} from "../utils/prefatturazioneCorsi";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Tooltip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Autocomplete,
  Button,
  Typography,
  Grid,
  TextField,
  Card,
  CardContent,
  CircularProgress,
  Paper,
  Backdrop,
  Stack,
  IconButton,
  Checkbox,
  Switch,
  Chip,
  FormControlLabel,
} from "@mui/material";
import PropTypes from "prop-types";
import unsplash from "../api/unsplash";
import {
  LocalizationProvider,
  DatePicker,
  PickersDay,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterMoment as DateAdapter } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import momentTimezone from "moment-timezone";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { openPdfDocument } from "../utils/openPdfDocument";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GlobalSnackbar from "./Snackbar";
import CircleIcon from "@mui/icons-material/Circle";
import CloseIcon from "@mui/icons-material/Close";
import { Output, Print, Restore, WindowSharp } from "@mui/icons-material";

const PrefatturazioneCorsi = () => {
  const [openSnack, setOpenSnack] = useState(false);
  const [snack, setSnack] = useState({
    severity: "success",
    messaggio: "Salvataggio Effettuato correttamente",
    open: false,
  });
  const [clienti, setClienti] = useState([]);
  const [clienteSel, setClienteSel] = useState(null);
  const [date, setDate] = useState(new Date());
  const [corsi, setCorsi] = useState([]);
  const [hasGenerated, setHasGenerated] = useState(false);
  const [open, setOpen] = useState(false);
  const [calculating, setCalculating] = useState(false);
  const generationRef = useRef(0);
  const [showSede, setShowSede] = useState(false);
  const [totale, setTotale] = useState(0);
  const [storicoFatturazioneCorsi, setStoricoFatturazioneCorsi] = useState([]);
  const [regolaElearning, setRegolaElearning] = useState("attivazione");
  const [savingRegola, setSavingRegola] = useState(false);
  const [regolaSalvata, setRegolaSalvata] = useState(null);
  const [mostraEsclusi, setMostraEsclusi] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };

  useEffect(() => {
    // è un loop qui carico i dati
    const fetchData = async () => {
      try {
        let response = await unsplash.get("clienti", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        });
        setClienti(response.data.data);
      } catch (error) {
        console.error(error.message);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    let active = true;
    setRegolaSalvata(null);
    setStoricoFatturazioneCorsi([]);
    if (clienteSel) {
      const config = {
        params: { cliente: clienteSel.ID },
        headers: { Authorization: `Bearer ${localStorage.getItem("jwt")}` },
      };
      Promise.all([
        unsplash.get("fatturazioneCorsi/regolaElearning", config),
        unsplash.get("storicoFatturazioneCorsi", config),
      ])
        .then(([regola, storico]) => {
          if (!active) return;
          setRegolaElearning(regola.data.data.RegolaElearning);
          setRegolaSalvata(regola.data.data.RegolaElearning);
          setStoricoFatturazioneCorsi(storico.data.data);
        })
        .catch(() => {
          if (!active) return;
          setSnack({
            severity: "error",
            messaggio: "Impossibile caricare le impostazioni del cliente",
          });
          setOpenSnack(true);
        });
    }
    return () => {
      active = false;
    };
  }, [clienteSel]);

  // Cache excluded courses with the result: showing them is a local view change.
  const corsiVisibili = corsi
    .map((tipo) => ({
      ...tipo,
      corsi: tipo.corsi.filter(
        (corso) => mostraEsclusi || corso.EsclusoPrefattura !== 1,
      ),
    }))
    .filter((tipo) => tipo.corsi.length > 0);

  useEffect(() => {
    generationRef.current += 1;
    setCalculating(false);
  }, [clienteSel, date]);

  const generateFatturazione = async (avvisaPeriodo = true) => {
    const request = ++generationRef.current;
    // storicoFatturazioneCorsi.filter(s => s.PeriodoFatturazione === )
    let mesi = {
      1: "GENNAIO",
      2: "FEBBRAIO",
      3: "MARZO",
      4: "APRILE",
      5: "MAGGIO",
      6: "GIUGNO",
      7: "LUGLIO",
      8: "AGOSTO",
      9: "SETTEMBRE",
      10: "OTTOBRE",
      11: "NOVEMBRE",
      12: "DICEMBRE",
    };
    let meseSel = mesi[moment(date).format("M")];
    let annoSel = moment(date).format("YYYY");

    let check = storicoFatturazioneCorsi.filter(
      (s) =>
        s.PeriodoFatturazione === meseSel && s.AnnoFatturazione === annoSel,
    );
    if (avvisaPeriodo && check.length > 0) {
      setSnack({
        severity: "warning",
        messaggio:
          "Attenzione hai già eseguito la fatturazione per questo periodo",
      });
      setOpenSnack(true);

      // return;
    }
    setCalculating(true);

    let idCliente = clienteSel.ID;
    let dataControllo = moment(date).endOf("month").format("YYYY-MM-DD");

    try {
      let response = await unsplash.get("fatturazioneCorsi", {
        params: {
          cliente: idCliente,
          data: dataControllo,
          includiEsclusi: true,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
      });
      //setCorsi(response.data.data);

      if (request !== generationRef.current) return;
      calcoloPrefatturazione(response.data.data);
      setHasGenerated(true);
    } catch {
      if (request !== generationRef.current) return;
      setSnack({
        severity: "error",
        messaggio: "Errore durante il calcolo della prefattura",
      });
      setOpenSnack(true);
    } finally {
      if (request === generationRef.current) setCalculating(false);
    }
  };

  const calcoloPrefatturazione = (costiCorsi) => {
    setCorsi(calcolaPrefatturazione(costiCorsi));
  };

  const aggiornaRiga = async (corso, partecipante, valori) => {
    try {
      await unsplash.put(
        valori.Presenza === undefined
          ? "fatturazioneCorsi"
          : "fatturazioneCorsi/presenza",
        {
          cliente: clienteSel.ID,
          riga: {
            Corso: corso.IDCorso,
            Lavoratore: partecipante.Lavoratore,
            ...valori,
          },
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem("jwt")}` } },
      );
      await generateFatturazione(false);
    } catch {
      setSnack({
        severity: "error",
        messaggio: "Errore durante il salvataggio della riga",
      });
      setOpenSnack(true);
    }
  };

  const salvaRegolaElearning = async () => {
    setSavingRegola(true);
    try {
      await unsplash.put(
        "fatturazioneCorsi/regolaElearning",
        {
          cliente: clienteSel.ID,
          regola: regolaElearning,
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem("jwt")}` } },
      );
      setCorsi([]);
      setHasGenerated(false);
      setRegolaSalvata(regolaElearning);
      setSnack({
        severity: "success",
        messaggio: "Regola e-learning salvata. Rigenera la prefattura.",
      });
      setOpenSnack(true);
    } catch {
      setSnack({
        severity: "error",
        messaggio: "Errore durante il salvataggio della regola",
      });
      setOpenSnack(true);
    } finally {
      setSavingRegola(false);
    }
  };

  const impostaEsclusione = async (corso, escluso) => {
    try {
      await unsplash.put(
        "fatturazioneCorsi/esclusione",
        {
          cliente: clienteSel.ID,
          corso: corso.IDCorso,
          escluso,
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem("jwt")}` } },
      );
      await generateFatturazione(false);
      setSnack({
        severity: "success",
        messaggio: escluso
          ? "Corso escluso anche dalle prefatture successive. Puoi ripristinarlo da Mostra esclusi."
          : "Corso ripristinato nelle prefatture.",
      });
      setOpenSnack(true);
    } catch {
      setSnack({
        severity: "error",
        messaggio: "Impossibile aggiornare l’esclusione del corso",
      });
      setOpenSnack(true);
    }
  };

  const stampaReport = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);
    var img = new Image();
    img.src = require("../assets/images/MILLERLogo-copia.jpg");

    let mesi = {
      1: "GENNAIO",
      2: "FEBBRAIO",
      3: "MARZO",
      4: "APRILE",
      5: "MAGGIO",
      6: "GIUGNO",
      7: "LUGLIO",
      8: "AGOSTO",
      9: "SETTEMBRE",
      10: "OTTOBRE",
      11: "NOVEMBRE",
      12: "DICEMBRE",
    };

    doc.setFillColor(34, 100, 174);
    doc.rect(0, 0, doc.internal.pageSize.getWidth(), 90, "F");

    doc.addImage(img, "PNG", 10, 10, 220, 70);
    doc.setTextColor(255, 255, 255);

    doc.setFont(undefined, "bold");
    doc.setFontSize(13);
    doc.text(
      "FATTURAZIONE CORSI : " +
        mesi[moment(date).format("M")] +
        " " +
        moment(date).format("YYYY"),
      255,
      30,
    );
    doc.text(
      doc.splitTextToSize(
        "CLIENTE : " + clienteSel.RagioneSociale.toUpperCase(),
        doc.internal.pageSize.getWidth() - 255,
      ),
      255,
      50,
    );
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(13);
    doc.text("ELENCO CORSI ", 250, 120);
    /*let content = {
      startY: 180,
      startX: 0,
      tableWidth: "auto",
      columnWidth: "auto",
      headStyles: { fillColor: [34, 100, 174] },
      footStyles: { fillColor: [34, 100, 174] },
      margin: { left: 0, right: 0 },
      // foot: [["", "", "", "Totale", Math.round(totale * 1e12) / 1e12]],
      showFoot: "lastPage",
    };*/

    for (let i = 0; i < corsi.length; i++) {
      if (!gruppoStampabile(corsi[i])) continue;
      let finalY = 120;
      if (doc.lastAutoTable.finalY) {
        finalY = doc.lastAutoTable.finalY;
      }

      doc.autoTable({
        useCss: true,
        startY: 20 + finalY,
        html: "#mytable" + i,
        headStyles: { fillColor: [124, 95, 240] },
      });
    }

    let finalY = 120;

    if (doc.lastAutoTable.finalY) {
      finalY = doc.lastAutoTable.finalY;
    }

    doc.autoTable({
      useCss: true,
      startY: 20 + finalY,
      html: "#footerTable",
      headStyles: { fillColor: [124, 95, 240] },
    });

    openPdfDocument(doc, "prefatturazione.pdf");
  };

  const confermaFatturazione = async () => {
    const stampabili = corsi.flatMap((tipo) =>
      tipo.corsi.filter((corso) => corso.MostraInStampa === 1),
    );
    if (
      stampabili.some(
        (corso) =>
          Number(corso.CostoAdHoc) === 1 &&
          (corso.ImportoOrario == null || corso.ImportoOrario === ""),
      )
    ) {
      setSnack({
        severity: "error",
        messaggio:
          "Inserire la quotazione oraria nel piano corsi e rigenerare la prefattura.",
      });
      setOpenSnack(true);
      return;
    }
    if (
      window.confirm("ATTENZIONE SEI SICURO DI VOLER GENERARE LA FATTURAZIONE?")
    ) {
      setOpen(true);
      try {
        await unsplash.post(
          "fatturazioneCorsi",
          {
            cliente: clienteSel.ID,
            data: moment(date).endOf("month").format("YYYY-MM-DD"),
            righe: righePrefatturazione(corsi),
            tariffeAdHoc: stampabili.map((corso) => ({
              Corso: corso.IDCorso,
              CostoAdHoc: Number(corso.CostoAdHoc) === 1,
              ImportoOrario: corso.ImportoOrario,
            })),
          },
          {
            headers: { Authorization: `Bearer ${localStorage.getItem("jwt")}` },
          },
        );
        stampaReport();
        setCorsi([]);
        setHasGenerated(false);
        await loadFatturazioneCorsi(clienteSel.ID);
        setSnack({
          severity: "success",
          messaggio: "Report stampato con successo",
        });
        setOpenSnack(true);
      } catch (error) {
        setSnack({
          severity: "error",
          messaggio:
            error.response?.data?.message ||
            "Errore durante la stampa. Rigenerare la prefattura e verificare le quotazioni.",
        });
        setOpenSnack(true);
      } finally {
        setOpen(false);
      }
    }
  };

  const loadFatturazioneCorsi = async (ID) => {
    let responseFatturazione = await unsplash.get(
      "storicoFatturazioneCorsi",
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
        params: { cliente: ID },
      }, //props.idAzienda}}
    );

    setStoricoFatturazioneCorsi(responseFatturazione.data.data);
  };

  return (
    <>
      <GlobalSnackbar
        severity={snack.severity}
        messaggio={snack.messaggio}
        openSnack={openSnack}
        handleCloseSnack={handleCloseSnack}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleClose}
      >
        <Stack>
          Calcolo
          <CircularProgress color="inherit" sx={{ marginLeft: "6px" }} />
        </Stack>
      </Backdrop>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm="auto" sx={{ width: { sm: 210 } }}>
                <LocalizationProvider dateAdapter={DateAdapter}>
                  <DatePicker
                    views={["month", "year"]}
                    label="Periodo"
                    value={moment(date)}
                    slotProps={{
                      textField: {
                        size: "small",
                        fullWidth: true,
                        sx: { "& .MuiInputBase-root": { height: 40 } },
                      },
                    }}
                    renderInput={(props) => (
                      <TextField {...props} size="small" fullWidth />
                    )}
                    onChange={(newValue) => {
                      setDate(newValue || null);
                      setCorsi([]);
                      setHasGenerated(false);
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid
                item
                xs={12}
                sm
                sx={{ maxWidth: { sm: 600 }, minWidth: { sm: 220 } }}
              >
                <Autocomplete
                  options={clienti}
                  fullWidth
                  size="small"
                  getOptionLabel={(option) => option.RagioneSociale}
                  onChange={(event, newValue) => {
                    setClienteSel(newValue);
                    setMostraEsclusi(false);
                    setCorsi([]);
                    setHasGenerated(false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Cliente"
                      fullWidth
                      size="small"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm="auto">
                <Button
                  variant="contained"
                  className="ButtonMiller"
                  disableElevation
                  sx={{ height: 40, px: 2.5, borderRadius: 1.5 }}
                  disabled={
                    calculating ||
                    !clienteSel ||
                    !date ||
                    savingRegola ||
                    regolaSalvata === null ||
                    regolaElearning !== regolaSalvata
                  }
                  onClick={() => generateFatturazione()}
                  startIcon={
                    calculating ? (
                      <CircularProgress size={16} color="inherit" />
                    ) : (
                      <Output />
                    )
                  }
                >
                  {calculating ? "Calcolo…" : "Genera"}
                </Button>
              </Grid>
              {clienteSel && (
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      alignItems: "center",
                      gap: 1.5,
                      p: 1.5,
                      bgcolor: "#f5f8fa",
                      border: "1px solid #e4ebef",
                      borderRadius: 2,
                    }}
                  >
                    <Tooltip
                      describeChild
                      title="Alla conclusione: verifica il completamento e abilita Fatturabile con la relativa data. La presenza resta separata."
                    >
                      <TextField
                        select
                        size="small"
                        label="Fatturazione e-learning"
                        sx={{
                          width: { xs: "100%", sm: 310 },
                          bgcolor: "white",
                        }}
                        SelectProps={{ native: true }}
                        value={regolaElearning}
                        onChange={(e) => {
                          setRegolaElearning(e.target.value);
                          setCorsi([]);
                          setHasGenerated(false);
                        }}
                      >
                        <option value="attivazione">
                          Nel mese di attivazione
                        </option>
                        <option value="completamento">
                          Alla conclusione (verifica manuale)
                        </option>
                      </TextField>
                    </Tooltip>
                    <Button
                      size="small"
                      variant="outlined"
                      sx={{
                        height: 40,
                        px: 2,
                        borderRadius: 1.5,
                        textTransform: "none",
                      }}
                      onClick={salvaRegolaElearning}
                      disabled={
                        savingRegola ||
                        regolaSalvata === null ||
                        regolaElearning === regolaSalvata
                      }
                    >
                      Salva regola
                    </Button>
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        gap: 2,
                        ml: { sm: "auto" },
                      }}
                    >
                      <Tooltip
                        describeChild
                        title="La X esclude il corso anche nei mesi successivi. Mostra gli esclusi per ripristinarli."
                      >
                        <FormControlLabel
                          sx={{ m: 0 }}
                          label="Mostra esclusi"
                          control={
                            <Switch
                              size="small"
                              checked={mostraEsclusi}
                              disabled={
                                open ||
                                regolaSalvata === null ||
                                regolaElearning !== regolaSalvata
                              }
                              onChange={(e) =>
                                setMostraEsclusi(e.target.checked)
                              }
                            />
                          }
                        />
                      </Tooltip>
                      <FormControlLabel
                        sx={{ m: 0 }}
                        label="Mostra sede"
                        control={
                          <Switch
                            size="small"
                            checked={showSede}
                            onChange={(e) => setShowSede(e.target.checked)}
                          />
                        }
                      />
                    </Box>
                  </Box>
                </Grid>
              )}
              <Grid item xs={12}>
                {hasGenerated && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      gap: 1,
                      mb: 1.5,
                      pt: 0.5,
                    }}
                  >
                    <Typography sx={{ color: "#11526f", fontWeight: 600 }}>
                      Totale da fatturare:{" "}
                      {Number(corsi.Totale || 0).toLocaleString("it-IT", {
                        style: "currency",
                        currency: "EUR",
                      })}
                    </Typography>
                    <Button
                      variant="contained"
                      className="ButtonMiller"
                      disableElevation
                      startIcon={<Print />}
                      sx={{ height: 36, px: 2, borderRadius: 1.5 }}
                      disabled={
                        open ||
                        calculating ||
                        !righePrefatturazione(corsi).length
                      }
                      onClick={confermaFatturazione}
                    >
                      Stampa fattura
                    </Button>
                  </Box>
                )}
                {hasGenerated && corsiVisibili.length === 0 && (
                  <Typography
                    variant="body2"
                    sx={{ color: "text.secondary", py: 2 }}
                  >
                    Nessun corso da fatturare per il periodo selezionato.
                  </Typography>
                )}
                {corsiVisibili.map((tipoCorso, indexTipoCorso) => (
                  <Accordion key={tipoCorso.Tipo}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      className="AccordionMiller"
                    >
                      <Typography>
                        {tipoCorso.DescrizioneCorso +
                          " - TOTALE " +
                          tipoCorso.totaleTipoCorso +
                          " €"}{" "}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      {tipoCorso.corsi.map((corso, indexCorsoSpecifico) => (
                        <Accordion key={corso.IDCorso}>
                          <AccordionSummary
                            expandIcon={
                              <ExpandMoreIcon
                                sx={{
                                  color:
                                    corso.EsclusoPrefattura === 1
                                      ? "#64748b"
                                      : "white",
                                }}
                              />
                            }
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            className={
                              corso.EsclusoPrefattura === 1
                                ? undefined
                                : "AccordionMiller"
                            }
                            sx={{
                              ...(corso.EsclusoPrefattura === 1
                                ? {
                                    bgcolor: "#f1f5f9",
                                    color: "#526171",
                                    borderLeft: "3px solid #cbd5e1",
                                  }
                                : {}),
                              "& .MuiAccordionSummary-content": {
                                alignItems: "center",
                                gap: 1,
                                flexWrap: "wrap",
                              },
                            }}
                          >
                            {corso.EsclusoPrefattura === 1 ? (
                              <Button
                                variant="outlined"
                                size="small"
                                startIcon={<Restore fontSize="small" />}
                                sx={{
                                  color: "#11526f",
                                  borderColor: "#b7cbd5",
                                  bgcolor: "white",
                                  borderRadius: 2,
                                  textTransform: "none",
                                  fontWeight: 600,
                                  flexShrink: 0,
                                  "&:hover": {
                                    bgcolor: "#e6f0f5",
                                    borderColor: "#11526f",
                                  },
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  impostaEsclusione(corso, false);
                                }}
                              >
                                Ripristina
                              </Button>
                            ) : (
                              <IconButton
                                aria-label="Escludi corso dalle prefatture"
                                title="Escludi anche dai periodi successivi"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  impostaEsclusione(corso, true);
                                }}
                              >
                                <CloseIcon sx={{ color: "#FF2768" }} />
                              </IconButton>
                            )}
                            {corso.EsclusoPrefattura === 1 && (
                              <Chip
                                label="Escluso"
                                size="small"
                                variant="outlined"
                                sx={{
                                  color: "#64748b",
                                  borderColor: "#cbd5e1",
                                  fontSize: "0.75rem",
                                }}
                              />
                            )}
                            <Typography>
                              {"Inizio : " +
                                moment(corso.DataInizio).format("DD/MM/YYYY") +
                                " - Fine : " +
                                moment(corso.DataFine).format("DD/MM/YYYY") +
                                "  - Durata : " +
                                corso.OreTotaliCorso +
                                " h - " +
                                corso.ModalitaDescrizione +
                                " - " +
                                (Number(corso.CostoAdHoc) === 1
                                  ? "Costo ad hoc orario"
                                  : corso.DescrizioneFatturazione
                                    ? corso.DescrizioneFatturazione
                                    : "Tariffa a Lavoratore") +
                                " - "}
                            </Typography>
                            <Typography>
                              {"Tariffa : " +
                                (Number(corso.CostoAdHoc) === 1
                                  ? corso.ImportoOrario + " € / ora"
                                  : corso.ModalitaFatturazione === 1
                                    ? corso.Tariffa + " €"
                                    : corso.CostoForfait + " €") +
                                (corso.Aggiornamento === 1
                                  ? " - Aggiornamento"
                                  : "") +
                                " - TOTALE : " +
                                corso.totaleCorso +
                                " €"}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            {corso.NoteFatturazione && (
                              <Typography
                                sx={{ mb: 2, whiteSpace: "pre-wrap" }}
                              >
                                {corso.NoteFatturazione}
                              </Typography>
                            )}
                            <TableContainer component={Paper}>
                              <Table
                                sx={{ minWidth: 650 }}
                                aria-label="simple table"
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Fatturabile</TableCell>
                                    <TableCell>Lavoratore</TableCell>
                                    <TableCell>
                                      Agenzia Di Riferimento
                                    </TableCell>
                                    {showSede && <TableCell>Sede</TableCell>}
                                    <TableCell>
                                      Presenza / completamento
                                    </TableCell>
                                    <TableCell>
                                      Data fatturabilità e-learning
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                {corso.Presenti.map((presente, index) => (
                                  <TableRow
                                    key={index}
                                    sx={{
                                      "&:last-child td, &:last-child th": {
                                        border: 0,
                                      },
                                    }}
                                  >
                                    <TableCell component="th" scope="row">
                                      <Checkbox
                                        inputProps={{
                                          "aria-label": `Fatturabile ${presente.NomeLavoratore}`,
                                        }}
                                        checked={
                                          corso.EsclusoPrefattura !== 1 &&
                                          daFatturare(presente)
                                        }
                                        disabled={
                                          corso.Modalita !== 3 ||
                                          corso.EsclusoPrefattura === 1
                                        }
                                        onChange={(e) =>
                                          aggiornaRiga(corso, presente, {
                                            Fatturabile: e.target.checked
                                              ? 1
                                              : 0,
                                            DataFatturabilita:
                                              presente.DataFatturabilita
                                                ? moment(
                                                    presente.DataFatturabilita,
                                                  ).format("YYYY-MM-DD")
                                                : moment(date)
                                                    .endOf("month")
                                                    .format("YYYY-MM-DD"),
                                          })
                                        }
                                      />
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                      {presente.NomeLavoratore}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                      {presente.AgenziaDiRiferimento}
                                    </TableCell>
                                    {showSede && (
                                      <TableCell component="th" scope="row">
                                        {presente.Sede}
                                      </TableCell>
                                    )}
                                    <TableCell>
                                      {corso.Modalita !== 3 ? (
                                        <Checkbox
                                          inputProps={{
                                            "aria-label": `Presenza ${presente.NomeLavoratore}`,
                                          }}
                                          checked={presente.EraPresente === 1}
                                          onChange={(e) =>
                                            aggiornaRiga(corso, presente, {
                                              Presenza: e.target.checked
                                                ? 1
                                                : 0,
                                            })
                                          }
                                        />
                                      ) : presente.EraPresente === 0 ? (
                                        "NO"
                                      ) : (
                                        "SI"
                                      )}
                                    </TableCell>
                                    <TableCell>
                                      {corso.Modalita === 3 && (
                                        <>
                                          <TextField
                                            type="date"
                                            size="small"
                                            label="Data fatturabilità"
                                            InputLabelProps={{ shrink: true }}
                                            value={
                                              presente.DataFatturabilita
                                                ? moment(
                                                    presente.DataFatturabilita,
                                                  ).format("YYYY-MM-DD")
                                                : ""
                                            }
                                            onChange={(e) =>
                                              e.target.value &&
                                              aggiornaRiga(corso, presente, {
                                                Fatturabile: 1,
                                                DataFatturabilita:
                                                  e.target.value,
                                              })
                                            }
                                          />
                                          <Button
                                            size="small"
                                            onClick={() =>
                                              aggiornaRiga(corso, presente, {
                                                Fatturabile: null,
                                              })
                                            }
                                          >
                                            Usa regola cliente
                                          </Button>
                                        </>
                                      )}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </Table>
                            </TableContainer>
                          </AccordionDetails>
                        </Accordion>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                ))}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      {corsi.map((corso, index) => (
        <>
          <Table
            sx={{ minWidth: 650, border: "1px solid black", display: "None" }}
            aria-label="simple table"
            id={"mytable" + index}
            size="small"
          >
            <TableHead>
              <TableRow>
                <TableCell className="tableHeaderMiller">
                  {corso.DescrizioneCorso}{" "}
                </TableCell>
                <TableCell
                  className="tableHeaderMiller"
                  sx={{ textAlign: "right!important" }}
                >
                  {" "}
                  {"TOTALE " + corso.totaleTipoCorso + " €"}
                </TableCell>
              </TableRow>
            </TableHead>

            {corso.corsi.map((corsoNelDettaglio) => {
              let head = "";

              if (corsoNelDettaglio.MostraInStampa === 1) {
                if (
                  corsoNelDettaglio.DataInizio === corsoNelDettaglio.DataFine
                ) {
                  head =
                    "Data Corso : " +
                    moment(corsoNelDettaglio.DataInizio).format("DD/MM/YYYY");
                } else {
                  head =
                    "Inizio : " +
                    moment(corsoNelDettaglio.DataInizio).format("DD/MM/YYYY") +
                    "Fine : " +
                    moment(corsoNelDettaglio.DataFine).format("DD/MM/YYYY");
                }

                return (
                  <>
                    <TableRow>
                      <TableCell colSpan={3} className="tableSubHeaderMiller">
                        {head +
                          " Durata : " +
                          corsoNelDettaglio.OreTotaliCorso +
                          " h - " +
                          (Number(corsoNelDettaglio.CostoAdHoc) === 1
                            ? "Costo ad hoc orario"
                            : corsoNelDettaglio.DescrizioneFatturazione
                              ? corsoNelDettaglio.DescrizioneFatturazione
                              : "Tariffa a Lavoratore") +
                          " - " +
                          corsoNelDettaglio.ModalitaDescrizione +
                          (corsoNelDettaglio.Aggiornamento === 1
                            ? " - Aggiornamento"
                            : "")}{" "}
                      </TableCell>
                    </TableRow>
                    {corsoNelDettaglio.NoteFatturazione && (
                      <TableRow>
                        <TableCell
                          colSpan={3}
                          style={{ whiteSpace: "pre-wrap" }}
                        >
                          {corsoNelDettaglio.NoteFatturazione}
                        </TableCell>
                      </TableRow>
                    )}
                    {corsoNelDettaglio.Presenti.map((lavoratore) => {
                      const dettaglioLavoratore =
                        lavoratore.NomeLavoratore +
                        (lavoratore.AgenziaDiRiferimento
                          ? ` - ${lavoratore.AgenziaDiRiferimento}`
                          : "") +
                        (showSede ? ` - ${lavoratore.Sede}` : "");

                      if (
                        daFatturare(lavoratore) &&
                        Number(corsoNelDettaglio.CostoAdHoc) !== 1 &&
                        (!corsoNelDettaglio.DescrizioneFatturazione ||
                          corsoNelDettaglio.DescrizioneFatturazione ===
                            "Tariffa a lavoratore")
                      ) {
                        return (
                          <TableRow>
                            <TableCell className="tableTextMiller">
                              {dettaglioLavoratore}
                            </TableCell>
                            <TableCell className="tableTextMiller">
                              {corsoNelDettaglio.Tariffa + " €"}{" "}
                            </TableCell>
                          </TableRow>
                        );
                      }
                      if (
                        daFatturare(lavoratore) &&
                        (Number(corsoNelDettaglio.CostoAdHoc) === 1 ||
                          corsoNelDettaglio.DescrizioneFatturazione ||
                          corsoNelDettaglio.DescrizioneFatturazione ===
                            "Forfait")
                      ) {
                        return (
                          <TableRow>
                            <TableCell colSpan={3} className="tableTextMiller">
                              {dettaglioLavoratore}{" "}
                            </TableCell>
                          </TableRow>
                        );
                      }
                    })}
                    <TableRow>
                      <TableCell
                        colSpan={3}
                        className="tableHeaderMiller"
                        sx={{ textAlign: "right!important" }}
                      >
                        <b>
                          {(Number(corsoNelDettaglio.CostoAdHoc) === 1
                            ? "QUOTAZIONE ORARIA AD HOC " +
                              corsoNelDettaglio.ImportoOrario +
                              " € / ora -"
                            : corsoNelDettaglio?.DescrizioneFatturazione ===
                                "Forfait"
                              ? "IMPORTO FORFAIT ORARIO " +
                                corsoNelDettaglio.CostoForfait +
                                " € -"
                              : "") +
                            " TOTALE CORSO " +
                            corsoNelDettaglio.totaleCorso +
                            " €"}{" "}
                        </b>
                      </TableCell>
                    </TableRow>
                  </>
                );
              }
            })}
          </Table>
        </>
      ))}

      <Table
        sx={{ minWidth: 650, border: "1px solid black", display: "none" }}
        aria-label="simple table"
        id={"footerTable"}
      >
        <TableHead>
          <TableRow>
            <TableCell
              colSpan={3}
              className="tableHeaderMiller"
              sx={{ textAlign: "right!important" }}
            >
              {" TOTALE DA FATTURARE " + corsi.Totale + " €"}{" "}
            </TableCell>
          </TableRow>
        </TableHead>
      </Table>
    </>
  );
};

export default PrefatturazioneCorsi;
